import  Head from "next/head";
import ContentPanes, { ContentPaneTypes } from "../components/ContentPanes";
import Layout from "../components/Layout";
//import styles from './upcoming-online-sessions.module.scss'
import Link from "next/link";
import CallOut from "../components/CallOut";

import { Price, LocalTimeFromUK } from "../components/Localization";
import { MenuId, useMenuContext } from "../components/Header";

import { GetServerSideProps } from 'next'
import { RusAuthProps, RusContextProps, Video } from "../lib/definitions";
import { DateTime } from "luxon";
import {VideoList} from "../components/Video";
import UnAuthContent from "../components/UnAuthContent";
import { getNextFewVideos } from "../lib/data";
import EmailSignupBanner from "../components/EmailSignupBanner";
import useAuth from "../lib/useAuth";

type Data = {
    videos : Video [],
    dateProcessed: string
      }
      
//export default function UpcomingSessions( {data} : InferGetServerSidePropsType<typeof getServerSideProps>)
export default function UpcomingSessions({data} : {data : Data} & RusAuthProps & RusContextProps)

{    
    const {setCurrentMenuId} = useMenuContext();
    let {loggedIn} = useAuth(); 
    
    return( 
        <Layout menuId={MenuId.online}>


        <Head>
            <title>Upcoming online sessions</title>
            <meta name="description" content="Upcoming art live streams. Figure and portrait drawing with expert tuition from professional artists."></meta>
        </Head>
        <div>
        <h1>Upcoming online sessions</h1>
        <p>
        We run regular, tutored online drawing sessions. They’re a great way to carve out a time to focus on your art each week. We run portrait drawing sessions every Sundays at <LocalTimeFromUK hours={16}/> and figure drawing on Wednesdays at <LocalTimeFromUK hours={20}/>. A tutor joins us, does a demonstration and gives hints and tips. At the end of the session you can share your work with the group for feedback and we give you a link so you can download the photographs and continue working on your drawings.
        </p>
        <UnAuthContent noRedirect={true}> <p>
Portrait sessions are <b>free</b> on the last Sunday of the month. Otherwise, sessions cost <Price gbp={5}/> each, or you can <Link href='/raw-umber-subscription'>subscribe</Link> for only <Price gbp={9.50}/> a month. {!loggedIn && <b>For a FREE taster session of your choosing, sign up below</b>}
        </p></UnAuthContent>
        <CallOut>
        <i>“This is the best drawing instruction I’ve seen anywhere”</i> – Miriam Danar
        </CallOut>

        <EmailSignupBanner/>
        <VideoList {...data} hideWarnings/>
    <ContentPanes contentPanes={[ContentPaneTypes.videoSearch,  ContentPaneTypes.playlists, ContentPaneTypes.imageSearch, ContentPaneTypes.threeDLibrary, ContentPaneTypes.subscribeNow, ContentPaneTypes.userImages]}/>
    
    <EmailSignupBanner/>
    </div>
    </Layout>  
    );
}


export const getServerSideProps: GetServerSideProps<{ data: Data }> = async (context) => {

  
 let vids = await getNextFewVideos();
 
    return {
      props: {
        data : {
        videos: vids,
        dateProcessed: DateTime.now().toISO()
        }
      },
    }
  }


